import PageHeader from "../../shared/page-header/PageHeader";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import React, { useRef, useState } from "react";
import Select from "react-select";
import axios from "axios";
import ReportDropdown from "../../shared/common-dropdown/ReportDropdown";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import DataTableExport from "./DataTableExport";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import moment from 'moment';
import { logAuditEvent } from '../../utils/auditLogger';

function ReportsMain(props) {
  const [showFilter, setShowFilter] = useState(false);
  const [filterByDropdown, setFilterByDropdown] = useState(false);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [title, seTitle] = useState('Report');
  const [alert] = useState(null);

  const [activeFilters, setActiveFilters] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [selectedReport, setSelectedReport] = useState(null);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [expandedContent, setExpandedContent] = useState(null);
  const [clientCompanyTypeOptions, setClientCompanyTypeOptions] = useState([]);
  const textFilterRef = useRef(null);
  const moduleName = props.Module || 'Reports';
  // Fetch ClientCompanyType options on mount
  React.useEffect(() => {
    const fetchClientCompanyTypeOptions = async () => {
      try {
        const clientCompanyTypeDetails = { UserId: getStorageValues('userId') };
        const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist", { params: clientCompanyTypeDetails });
        if (response.status === 200 && response.data?.data?.[0]) {
          const options = response.data.data[0].map(cct => ({
            value: cct.ClientCompanyTypeId,
            label: cct.ClientCompanyTypeName
          }));
          setClientCompanyTypeOptions(options);
        }
      } catch (error) {
        console.log('Error fetching ClientCompanyType options:', error);
      }
    };
    fetchClientCompanyTypeOptions();
  }, []);

  React.useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Reports');
  }, [moduleName]);
  const [reportFilters, setReportFilters] = useState({
    ClientCompanyTypeList: [
      { key: "FilterTextClientCompanyType", label: "Company", type: "text", field: "ClientCompanyTypeName" }
    ],
    ClientList: [
      { key: "FilterTextClient", label: "Search", type: "text", field: "ClientName" },
      { key: "FilterDDTaxStatus", label: "Tax Status", type: "dropdown", field: "TaxStatusId", options: [] },
      { key: "FilterDDModeOfHolding", label: "Mode of Holding", type: "dropdown", field: "ModeOfHolding", options: [] },
      { key: "FilterDDClientRatings", label: "Client Rating", type: "dropdown", field: "ClientRating", options: [] },
      { key: "FilterDDReferedBy", label: "Referred By", type: "dropdown", field: "ReferedBy", options: [] },
      { key: "FilterDDFamilyHead", label: "Family Head", type: "dropdown", field: "FamilyHeadName", options: [] },
      { key: "FilterDDGender", label: "Gender", type: "dropdown", field: "Gender", options: [] },
      { key: "FilterDTDateOfBirth", label: "Date of Birth", type: "daterange", field: "DateOfBirth" },
      { key: "FilterDTDateOfAnniversary", label: "Date of Anniversary", type: "daterange", field: "DateOfAnniversary" },
    ],

    ClientCompanyList: [
      { key: "FilterTextClientCompany", label: "Company", type: "text", field: "ClientCompanyName" },
      { key: "FilterDDClientCompanyType", label: "Company Type", type: "dropdown", field: "ClientCompanyTypeId", options: [] }
    ],
    TaskingList: [
      { key: "FilterTextTask", label: "Text", type: "text", field: "TaskKey" },
      { key: "FilterDDTaskKey", label: "Task Key", type: "dropdown", field: "TaskId", options: [] },
      { key: "FilterDDTitle", label: "Title", type: "dropdown", field: "TitleId", options: [] },
      { key: "FilterDDClientName", label: "Client Name", type: "dropdown", field: "ClientId", options: [] },
      { key: "FilterDDClientCompany", label: "Client Company", type: "dropdown", field: "ClientCompanyId", options: [] },
    ],
    UserList: [
      { key: "FilterTextUsers", label: "Search Text", type: "text", field: "FullName" },
      { key: "FilterDDRoles", label: "Role", type: "dropdown", field: "RoleId", options: [] }
    ],
  });

  const filteredData = data.filter(row => {
    // If no report selected, don't apply report-specific filters
    if (!selectedReport) return true;

    const filtersForReport = reportFilters[selectedReport] || [];

    return activeFilters.every(filterKey => {
      const filter = filtersForReport.find(f => f.key === filterKey);
      const value = filterValues[filterKey];

      // If filter definition not found or no value set, don't block the row
      if (!filter || !value) return true;

      switch (filter.type) {

        case "text": {
          const search = (value || "").toString().toLowerCase();
          // Search across all fields in the row. This covers nested objects/arrays
          // by stringifying them and checking for the search term.
          return Object.values(row || {}).some(v => {
            if (v === null || v === undefined) return false;
            let str;
            if (typeof v === 'object') {
              try {
                str = JSON.stringify(v);
              } catch (err) {
                str = String(v);
              }
            } else {
              str = String(v);
            }
            return str.toLowerCase().includes(search);
          });
        }

        case "dropdown": {
          debugger;
          // Handle multi-select: value is an array of {value, label} objects
          const selectedValues = Array.isArray(value) ? value.map(v => v.value) : (value?.value ? [value.value] : []);
          if (selectedValues.length === 0) return true; // No filter applied
          return selectedValues.includes(row[filter.field]);
        }

        case "date":
          return row[filter.field] === value;

        case "daterange": {
          const raw = row[filter.field];
          if (!raw) return false; // omit rows with no date when filtering
          // Parse row date supporting ISO or DD/MM/YYYY
          const rowDate = moment(raw, [moment.ISO_8601, 'DD/MM/YYYY', 'YYYY-MM-DD'], true);
          if (!rowDate.isValid()) return false;
          const hasFrom = !!value?.from;
          const hasTo = !!value?.to;
          const from = hasFrom ? moment(value.from, ['YYYY-MM-DD', 'DD/MM/YYYY'], true).startOf('day') : null;
          const to = hasTo ? moment(value.to, ['YYYY-MM-DD', 'DD/MM/YYYY'], true).endOf('day') : null;
          const inFrom = !hasFrom || rowDate.isSameOrAfter(from);
          const inTo = !hasTo || rowDate.isSameOrBefore(to);
          return inFrom && inTo;
        }

        default:
          return true;
      }
    });
  });

  // Component to render cell with ellipsis and conditional tooltip only when overflowed.
  const TruncatableCell = ({ text }) => {
    const ref = React.useRef(null);
    const [isOverflow, setIsOverflow] = React.useState(false);

    React.useEffect(() => {
      const el = ref.current;
      if (!el) return;
      const check = () => setIsOverflow(el.scrollWidth > el.clientWidth + 1);
      check();
      window.addEventListener('resize', check);
      return () => window.removeEventListener('resize', check);
    }, [text]);

    return (
      <span
        ref={ref}
        title={isOverflow ? (text ?? '') : undefined}
        style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }}
        onClick={() => setExpandedContent(text ?? '')}
      >
        {text}
      </span>
    );
  };

  const closeExpanded = () => setExpandedContent(null);

  // Enhance columns to ensure each has a cell renderer that uses TruncatableCell
  const enhanceColumns = (cols) => {
    return cols.map(col => {
      if (col.cell) return col;
      return {
        ...col,
        cell: row => {
          try {
            const val = typeof col.selector === 'function' ? col.selector(row) : '';
            return <TruncatableCell text={val ?? ''} />;
          } catch (err) {
            return <TruncatableCell text={''} />;
          }
        }
      };
    });
  };

  
  const renderFilterInput = (filter) => {
    if (!filter) return null;
    switch (filter.type) {

      case "text":
        return (
            <input
              ref={textFilterRef}
              type="text"
              className="form-control form-control-sm"
              placeholder={`Search Text`}
              value={filterValues[filter.key] || ""}
              onChange={e => handleFilterChange(filter.key, e.target.value)}
              style={{ height: "38px", marginTop: "10px", width: "250px"}}
            />
        );

      case "dropdown": {
        // Inject dynamic options for specific filters
        let options = filter.options;
        if (filter.key === "FilterDDClientCompanyType") {
          options = clientCompanyTypeOptions;
        } else {
          options = filter.options || [];
        }

        const selectedValues = filterValues[filter.key] || [];
        const placeholderText = selectedValues.length > 0 
          ? `${selectedValues.length} selected` 
          : `Select ${filter.label}`;
        return (
          <Select
            isMulti
            options={options}
            value={selectedValues}
            onChange={(e) => handleFilterChange(filter.key, e)}
            isClearable
            placeholder={placeholderText}
            styles={{ control: (base) => ({ ...base, minWidth: '250px', marginTop: '10px' }) }}
          />
        );
      }

      case "date":
        return (
          <input
            type="date"
            value={filterValues[filter.key] || ""}
            onChange={(e) => handleFilterChange(filter.key, e.target.value)}
            className="form-control"
          />
        );

      case "daterange":
        return (
          <div className="d-flex gap-2">
            <input
              type="date"
              className="form-control"
              value={filterValues[filter.key]?.from || ""}
              onChange={(e) =>
                handleFilterChange(filter.key, {
                  ...filterValues[filter.key],
                  from: e.target.value,
                })
              }
            />
            <input
              type="date"
              className="form-control"
              value={filterValues[filter.key]?.to || ""}
              onChange={(e) =>
                handleFilterChange(filter.key, {
                  ...filterValues[filter.key],
                  to: e.target.value,
                })
              }
            />
          </div>
        );

      default:
        return null;
    }
  };

  async function handleReportChange(e) {
    let renderFilterByDropdown = null;
    logAuditEvent(moduleName, 'Report Selection', e ? `Selected ${e.name}` : 'Cleared selection');
    if (e === null) {
      setSelectedReport(null);
      setShowFilter(false);
      setData([]);
      setColumns([]);
      seTitle("");
    } else {
      setSelectedReport(e.name);
      setShowFilter(true);
      processReports(e.name);
      seTitle(e.label);
      if (e.name === "ClientCompanyTypeList") {
        renderFilterByDropdown = (
          <>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterTextClientCompanyType"
              className="dropdown-item"
            >
              Text
            </Link>
          </>
        );
      } else if (e.name === "ClientCompanyList") {
        renderFilterByDropdown = (
          <>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterTextClientCompany"
              className="dropdown-item"
            >
              Text
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDClientCompanyType"
              className="dropdown-item"
            >
              Client Company Type
            </Link>
          </>
        );
      } else if (e.name === "ClientList") {
        renderFilterByDropdown = (
          <>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterTextClient"
              className="dropdown-item"
            >
              Text
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDTaxStatus"
              className="dropdown-item"
            >
              Tax Status
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDModeOfHolding"
              className="dropdown-item"
            >
              Mode of holding
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDClientRatings"
              className="dropdown-item"
            >
              Client Ratings
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDReferedBy"
              className="dropdown-item"
            >
              Refered By
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDFamilyHead"
              className="dropdown-item"
            >
              Family Head
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDGender"
              className="dropdown-item"
            >
              Gender
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDTDateOfBirth"
              className="dropdown-item"
            >
              Date Of Birth
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDTDateOfAnniversary"
              className="dropdown-item"
            >
              Date Of Anniversary
            </Link>
          </>
        );
      } else if (e.name === "UserList") {
        renderFilterByDropdown = (
          <>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterTextUsers"
              className="dropdown-item"
            >
              Text
            </Link>
             <Link
                onClick={(evt) => onFilterByClick(evt)}
                name="FilterDDRoles"
                className="dropdown-item"
              >
                Roles
              </Link>
          </>
        );
      } else if (e.name === "TaskingList") {
        renderFilterByDropdown = (
          <>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterTextTask"
              className="dropdown-item"
            >
              Text
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDTaskKey"
              className="dropdown-item"
            >
              Task Key
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDTitle"
              className="dropdown-item"
            >
              Title
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDClientName"
              className="dropdown-item"
            >
              Client Name
            </Link>
            <Link
              onClick={(evt) => onFilterByClick(evt)}
              name="FilterDDClientCompany"
              className="dropdown-item"
            >
              Client Company
            </Link>
          </>
        );
      }
    }
    setFilterByDropdown(renderFilterByDropdown);
  }

  async function processReports(reportName) {
    logAuditEvent(moduleName, 'Generate Report', reportName);
    if (reportName === "ClientCompanyTypeList") {
      const columns = [
        { name: "Client Company Type", selector: row => row.ClientCompanyTypeName, cell: row => <span title={row.ClientCompanyTypeName}>{row.ClientCompanyTypeName}</span> },
        { name: "Description", selector: row => row.Description, cell: row => <span title={row.Description}>{row.Description}</span> }
      ];

      let ClientCompanyTypeDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist", ClientCompanyTypeDetails);
      if (response.status === 200) {
        setData(response.data.data[0]);
        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    } else if (reportName === "ClientCompanyList") {
      const columns = [
        { name: "Client Company Type", selector: row => row.ClientCompanyTypeName },
        { name: "Client Company", selector: row => row.ClientCompanyName },
        { name: "Description", selector: row => row.Description },
        { name: "RMO Name 1", selector: row => row.RMName1 },
        { name: "RMO Contact 1", selector: row => row.RMContact1 },
        { name: "RMO Name 2", selector: row => row.RMName2 },
        { name: "RMO Contact 2", selector: row => row.RMContact2 },
        { name: "RMO Name 3", selector: row => row.RMName3 },
        { name: "RMO Contact 3", selector: row => row.RMContact3 },
      ];

      let ClientCompanyDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanylist", ClientCompanyDetails);
      if (response.status === 200) {
        setData(response.data.data[0]);
        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    } else if (reportName === "ClientList") {
      // ✅ Client List Columns
      const columns = [
        { name: "Client Name", selector: row => row.ClientDisplayName, width: '200px' },
        { name: "Tax Status", selector: row => row.TaxStatus },
        { name: "Mode of Holding", selector: row => row.ModeOfHolding, width: '130px' },
        { name: "Client Rating", selector: row => row.ClientRating, width: '120px' },
        { name: "Referred By", selector: row => row.ReferedBy, width: '200px'  },
        { name: "Family Head", selector: row => row.FamilyHeadName, width: '200px'  },
        { name: "Gender", selector: row => row.Gender },
        { name: "Email", selector: row => row.EmailId, width: '200px' },
        { name: "Mobile", selector: row => row.MobileNumber, width: '120px' },
        { name: "Date of Birth", selector: row => row.DateOfBirth, width: '120px', cell: row => <span title={row.DateOfBirth}>{row.DateOfBirth ? moment(row.DateOfBirth).format('DD/MM/YYYY') : ''}</span> },
        { name: "Place of Birth", selector: row => row.PlaceOfBirth, width: '120px' },
        { name: "Country Of Birth", selector: row => row.CountryOfBirth, width: '130px' },
        { name: "Occupation", selector: row => row.Occupation },
        { name: "Nominee", selector: row => row.Nominee },
        { name: "PAN No", selector: row => row.PANNo, width: '130px' },
        { name: "Address", selector: row => row.AddressDisplay, width: '300px' },
        { name: "DP Id", selector: row => row.DPId },
        { name: "Annual Income", selector: row => row.AnnualIncome, width: '130px' },
        { name: "Gross Annual Income", selector: row => row.GrossAnnualIncome, width: '160px' },
        { name: "Net Worth", selector: row => row.NetWorth },
        { name: "Bank Name", selector: row => row.BankName },
        { name: "Branch Name", selector: row => row.BranchName },
        { name: "Account Number", selector: row => row.AccountNumber, width: '130px' },
        { name: "IFSC Code", selector: row => row.IFSCCode },
      ];

      // ✅ Fetch Client List from backend
      const ClientDetails = { UserId: getStorageValues('userId') };
      const response = await axios.get(getApiBaseUrl() + "/clientlist", ClientDetails);

      if (response.status === 200 && response.data?.data?.[0]) {
        const clientList = response.data.data[0];
        setData(response.data.data[0]);

        const distinctTaxStatus = [
          ...new Map(
            clientList
              .filter(u => u.TaxStatusId && u.TaxStatus)
              .map(u => [u.TaxStatusId, { value: u.TaxStatusId, label: u.TaxStatus }])
          ).values()
        ];

        const distinctModeOfHolding = [
          ...new Map(
            clientList
              .filter(u => u.ModeOfHolding)
              .map(u => [u.ModeOfHolding, { value: u.ModeOfHolding, label: u.ModeOfHolding }])
          ).values()
        ];

        const distinctClientRating = [
          ...new Map(
            clientList
              .filter(u => u.ClientRating)
              .map(u => [u.ClientRating, { value: u.ClientRating, label: u.ClientRating }])
          ).values()
        ];

        const distinctReferedBy = [
          ...new Map(
            clientList
              .filter(u => u.ReferedBy)
              .map(u => [u.ReferedBy, { value: u.ReferedBy, label: u.ReferedBy }])
          ).values()
        ];

        const distinctFamilyHead = [
          ...new Map(
            clientList
              .filter(u => u.FamilyHeadName)
              .map(u => [u.FamilyHeadName, { value: u.FamilyHeadName, label: u.FamilyHeadName }])
          ).values()
        ];

        const distinctGender = [
          ...new Map(
            clientList
              .filter(u => u.Gender)
              .map(u => [u.Gender, { value: u.Gender, label: u.Gender }])
          ).values()
        ];

        setReportFilters(prev => ({
          ...prev,
          ClientList: prev.ClientList.map(f =>
            f.key === "FilterDDTaxStatus"
              ? { ...f, options: distinctTaxStatus }
              : f.key === "FilterDDModeOfHolding"
              ? { ...f, options: distinctModeOfHolding }
              : f.key === "FilterDDClientRatings"
              ? { ...f, options: distinctClientRating }
              : f.key === "FilterDDReferedBy"
              ? { ...f, options: distinctReferedBy }
              : f.key === "FilterDDFamilyHead"
              ? { ...f, options: distinctFamilyHead }
              : f.key === "FilterDDGender"
              ? { ...f, options: distinctGender }
              : f
          )
        }));

        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    } else if (reportName === "LeadList") {
      const columns = [
        { name: "Client Name", selector: row => row.ClientName },
        { name: "Mobile Number", selector: row => row.MobileNumber },
        { name: "Email Id", selector: row => row.EmailId },
        { name: "Description", selector: row => row.Description },
        { name: "Product Investment", selector: row => row.ClientCompanyTypeNames },
        { name: "IsConverted", selector: row => row.IsConverted }
      ];

      let leadDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/leadList", leadDetails);
      if (response.status === 200) {
        setData(response.data.data[0]);
        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    } else if (reportName === "TaskingList") {
      const columns = [
        { name: "Task Key", selector: row => row.TaskKey },
        { name: "Title", selector: row => row.Title },
        { name: "Client", selector: row => row.ClientName },
        { name: "Client Company", selector: row => row.ClientCompanyName },
        { name: "Priority", selector: row => row.Priority },
        { name: "Assigned To", selector: row => row.AssignedTo },
        { name: "Created By", selector: row => row.CreatedBy },
        { name: "Status", selector: row => row.Status },
        { name: "Reference Number", selector: row => row.ReferenceNumber },
        { name: "Created Date", selector: row => row.CreatedDate, cell: row => <span title={row.CreatedDate}>{row.CreatedDate ? moment(row.CreatedDate).format('DD/MM/YYYY') : ''}</span> },
        { name: "Next Followup Date", selector: row => row.NextFollowupDate, cell: row => <span title={row.NextFollowupDate}>{row.NextFollowupDate ? moment(row.NextFollowupDate).format('DD/MM/YYYY') : ''}</span> }
      ];
      
      const response = await axios.get(getApiBaseUrl() + "/tasklist", { params: { UserId: getStorageValues('userId'), ByUser: 0 } });
      if (response.status === 200 && response.data?.data?.[0]) {
        const taskList = response.data.data[0];
        setData(response.data.data[0]);

        const distinctClientName = [
          ...new Map(
            taskList
              .filter(u => u.ClientId && u.ClientName)
              .map(u => [u.ClientId, { value: u.ClientId, label: u.ClientName }])
          ).values()
        ];

        const distinctTitle = [
          ...new Map(
            taskList
              .filter(u => u.TitleId && u.Title)
              .map(u => [u.TitleId, { value: u.TitleId, label: u.Title }])
          ).values()
        ];

        const distinctTaskKey = [
          ...new Map(
            taskList
              .filter(u => u.TaskId && u.TaskKey)
              .map(u => [u.TaskId, { value: u.TaskId, label: u.TaskKey }])
          ).values()
        ];

        const distinctClientCompany = [
          ...new Map(
            taskList
              .filter(u => u.ClientCompanyId && u.ClientCompany)
              .map(u => [u.ClientCompanyId, { value: u.ClientCompanyId, label: u.ClientCompany }])
          ).values()
        ];

        // update reportFilters properly
        setReportFilters(prev => ({
          ...prev,
          TaskingList: prev.TaskingList.map(f =>
            f.key === "FilterDDClientName"
              ? { ...f, options: distinctClientName }
              : f.key === "FilterDDTitle"
              ? { ...f, options: distinctTitle }
              : f.key === "FilterDDTaskKey"
              ? { ...f, options: distinctTaskKey }
              : f.key === "FilterDDClientCompany"
              ? { ...f, options: distinctClientCompany }
              : f
          )
        }));

        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    } else if (reportName === "UserList") {
      const columns = [
        { name: "Full Name", selector: row => row.FullName },
        { name: "User Name", selector: row => row.UserName },
        { name: "Email", selector: row => row.Email },
        { name: "Phone", selector: row => row.PhoneNumber },
        { name: "Email Confirmed", selector: row => row.EmailConfirmed },
        { name: "Phone Confirmed", selector: row => row.PhoneNumberConfirmed },
        { name: "Status", selector: row => row.Status },
        { name: "Role", selector: row => row.RoleName },
        { name: "Default Module", selector: row => row.DefaultModuleName }
      ];

      let userDetails = { UserId: getStorageValues('userId') };
      const response = await axios.get(getApiBaseUrl() + "/userlist", userDetails);
      if (response.status === 200 && response.data?.data?.[0]) {
        const userList = response.data.data[0];
        setData(userList);

        const distinctRoles = [
          ...new Map(
            userList
              .filter(u => u.RoleId && u.RoleName)
              .map(u => [u.RoleId, { value: u.RoleId, label: u.RoleName }])
          ).values()
        ];

        // update reportFilters properly
        setReportFilters(prev => ({
          ...prev,
          UserList: prev.UserList.map(f =>
            f.key === "FilterDDRoles"
              ? { ...f, options: distinctRoles }
              : f
          )
        }));

        const enhanced = enhanceColumns(columns);
        setColumns(enhanced);
        initializeColumnVisibility(enhanced);
      }
    }

  }
  const onFilterByClick = (e) => {
    const filterName = e.currentTarget.getAttribute('name');

    setActiveFilters(prev => {
      const next = Array.from(new Set([...(prev || []), filterName]));
      return next;
    });

    // Auto-focus AFTER filter input is rendered
    setTimeout(() => {
      if (filterName.includes("FilterText") && textFilterRef.current) {
        textFilterRef.current.focus();
        textFilterRef.current.select(); // optional (select text)
      }
    }, 50);  // increased to ensure the input is mounted
  };

  const handleFilterChange = (key, value) => {
    setFilterValues(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleColumnToggle = (columnName) => {
    setColumnVisibility(prev => {
      // determine current visible count (treat undefined as visible)
      const visibility = { ...prev };
      const values = Object.keys(visibility).length > 0
        ? Object.values(visibility)
        : columns.map(() => true);
      const visibleCount = values.filter(v => v !== false).length;
      const currentlyVisible = visibility[columnName] !== false;

      // Prevent hiding the last visible column
      if (currentlyVisible && visibleCount <= 1) {
        return prev; // no change
      }

      return {
        ...prev,
        [columnName]: !currentlyVisible
      };
    });
  };

  const visibleColumns = columns.filter(col => columnVisibility[col.name] !== false);

  const initializeColumnVisibility = (cols) => {
    const visibility = {};
    cols.forEach(col => {
      visibility[col.name] = true;
    });
    setColumnVisibility(visibility);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayText={"Generate "}
        displayModule={props.Module}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={false}
      />

      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top d-flex align-items-center justify-content-between">
            <div className="search-set d-flex align-items-center">
              {/* Report Dropdown */}
              <div style={{ minWidth: '300px' }}>
                <label className="form-label" style={{ marginBottom: '4px' }}>Reports</label>
                <div>
                  <ReportDropdown
                    modelName="ReportId"
                    required={true}
                    onReportChange={handleReportChange}
                  />
                </div>
              </div>

              {/* Filter icon and dropdown */}
              {showFilter && (
                <>
                  <Link
                    className="ms-2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="Filter By"
                  >
                    <Icons.Filter color="#0c4777" />
                  </Link>
                  <div className="dropdown-menu notes-menu dropdown-menu-end">
                    {filterByDropdown}
                  </div>
                </>
              )}

              {/* Active filters container */}
              <div id="FilterContainer" className="filter-dropdown-container">
                {Array.from(new Set(activeFilters)).map((filterKey) => {
                  const filter = reportFilters[selectedReport]?.find(f => f.key === filterKey);
                  if (!filter) return null; // skip unknown filter keys
                  return (
                    <div key={filterKey} className="filter-dropdown-wrapper">
                      {renderFilterInput(filter)}
                      <span
                        className="remove-icon"
                        onClick={() => {
                          setActiveFilters(prev => Array.from(new Set((prev || []).filter(k => k !== filterKey))));
                          setFilterValues(prev => {
                            const copy = { ...prev };
                            delete copy[filterKey];
                            return copy;
                          });
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right-side actions (settings) */}
            <div className="right-actions d-flex align-items-center">
              {showFilter && (
                <div className="dropdown" style={{ position: 'relative' }}>
                  <Link
                    className="ms-2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="Column Configuration"
                  >
                    <Icons.Settings size={18} color="#0c4777" />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end" style={{ minWidth: '200px' }} onClick={(e) => e.stopPropagation()}>
                    <div style={{ padding: '8px', maxHeight: '300px', overflowY: 'auto' }}>
                      {columns.map((col) => (
                        <div
                          key={col.name}
                          className="dropdown-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            userSelect: 'none',
                            backgroundColor: 'transparent'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleColumnToggle(col.name);
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          <input
                            type="checkbox"
                            checked={columnVisibility[col.name] !== false}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleColumnToggle(col.name);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              marginRight: '8px',
                              cursor: 'pointer'
                            }}
                          />
                          <label style={{ margin: 0, cursor: 'pointer', flex: 1 }}>
                            {col.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>


      <DataTableExport
        title={title}
        columns={visibleColumns}
        data={filteredData}
      />

      {expandedContent && (
        <div
          className="modal-backdrop"
          onClick={closeExpanded}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000
          }}
        >
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={{
              backgroundColor: '#fff',
              padding: '16px',
              borderRadius: '6px',
              maxWidth: '80%',
              maxHeight: '80%',
              overflow: 'auto',
              boxShadow: '0 6px 18px rgba(0,0,0,0.2)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button className="btn-close" onClick={closeExpanded} aria-label="Close"></button>
            </div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{expandedContent}</div>
          </div>
        </div>
      )}

    </>
  );
}

export default ReportsMain;
